import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Edit } from 'jbc-front/components/icons';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import { Grid } from '@/components/ui/Grid';
import { Dd, Dl, Dt } from '@/components/ui/DefinitionList';
import { dateFormat } from '@/components/utils/formatter';
import { ViewProps } from './ViewProps';

export const SubmitOn: FC<ViewProps> = ({ report, editLink }) => {
  return (
    <Panel>
      <Link to={`${editLink}#submit_on`}>
        <Headding icon={<Edit icon={16} />}>提出年月日</Headding>
      </Link>
      <Item>
        <Grid>
          <Dl>
            <Dt>提出年月日</Dt>
            <Dd>{dateFormat(report.submitOn, 'seireki')}</Dd>
          </Dl>
        </Grid>
      </Item>
    </Panel>
  );
};
